import * as React from 'react';
import {
    bidderPreferenceLoadedSelector,
    bidderPreferenceSelector,
    updateBidderPreferences,
} from '@/redux/modules/bidderPreference';
import { currencies } from '@/enums';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getPreferredCurrencyCookie, setPreferredCurrencyCookie } from '@/redux/modules/cookies';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import AnchoredPopover from '@liveauctioneers/caterwaul-components/lib/Popover/AnchoredPopover';
import CurrencySelection from './CurrencySelection';
import styled from 'styled-components';

// 1 min
const timeToDisplay = 60000;

const CurrencySelectionPopover = () => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();
    const checkoutPage = pathname.includes('/checkout/');
    const biddingConsole = pathname.includes('/console/');
    const profilePage = pathname.includes('/dashboard/profile');
    const bidderPreferences = useAppSelector(bidderPreferenceSelector);
    const bidderPreferenceLoaded = useAppSelector(bidderPreferenceLoadedSelector);
    const [show, setShow] = React.useState(false);
    const cookie = useAppSelector(getPreferredCurrencyCookie);

    const onClose = React.useCallback(() => {
        dispatch(setPreferredCurrencyCookie());
        dispatch(
            updateBidderPreferences({
                ...bidderPreferences,
                preferredCurrency: currencies.NoCurrency,
            })
        );
        setShow(false);
    }, [dispatch, bidderPreferences]);

    React.useEffect(() => {
        if (!cookie && Boolean(bidderPreferenceLoaded)) {
            if (bidderPreferences.preferredCurrency !== currencies.NoCurrency) {
                dispatch(setPreferredCurrencyCookie());
                setShow(false);
            } else {
                setShow(true);
                window.setTimeout(() => setShow(false), timeToDisplay);
            }
        }
    }, [dispatch, bidderPreferenceLoaded, bidderPreferences, cookie]);

    //never render on the profile page, checkout, or bidding console
    if (profilePage || biddingConsole || checkoutPage) {
        return null;
    }

    return (
        <AnchoredPopover bottom={25} right={25} show={show}>
            <StyledCurrencySelectionPopover>
                <StyledPopoverHeader>
                    <h3>
                        <FormattedMessage id="preferredCurrencyConversion.changeCurrency" />
                    </h3>
                    <StyledPopoverClose icon={faTimes} onClick={onClose} />
                </StyledPopoverHeader>
                <CurrencySelection />
            </StyledCurrencySelectionPopover>
        </AnchoredPopover>
    );
};

export default CurrencySelectionPopover;

const StyledCurrencySelectionPopover = styled.div`
    padding: 15px;
    width: 250px;
    background-color: ${({ theme }) => theme.colors.beige100};
`;

const StyledPopoverHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
`;

const StyledPopoverClose = styled(FontAwesomeIcon)`
    cursor: pointer;
    && {
        width: 20px;
        height: 20px;
    }
`;
